export default __webpack_public_path__ + "static/media/noPhoto.0d36f28b.webp";